import { render, staticRenderFns } from "./ElementYearResultGrowthTableColumn.vue?vue&type=template&id=5828d79c&scoped=true"
import script from "./ElementYearResultGrowthTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementYearResultGrowthTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementYearResultGrowthTableColumn.vue?vue&type=style&index=0&id=5828d79c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828d79c",
  null
  
)

export default component.exports